import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-portal-logo-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-portal-logo-svg-icon.component.html',
  styleUrl: './ln-portal-logo-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnPortalLogoSvgIconComponent {
  @Input() class = 'w-12 h-9 sm:w-52 sm:h-24';
}
